import React, { Fragment, useMemo } from 'react';
import T from 'prop-types';

import WarningNotification from '../WarningNotification';
import RadioButtonGroup from '../../../RadioButtonGroup';

export const formatTypes = [
  ['xls', 'XLSX'],
  ['csv', 'CSV'],
];
const ExportType = ({ active, disableXLS, onChange }) => {
  const options = useMemo(
    () =>
      formatTypes.map(([value, text]) => ({
        id: value,
        value,
        text,
        disabled: value === 'xls' ? disableXLS : false,
        subElement:
          value === 'xls' ? (
            <WarningNotification
              text={
                disableXLS ? (
                  'Format not supported with selected metrics.'
                ) : (
                  <Fragment>
                    Large reports may produce too much data for Excel.
                    <br />
                    If the export fails, you will be prompted to export as CSV instead.
                  </Fragment>
                )
              }
              className="ml-mdl"
            />
          ) : undefined,
      })),
    [disableXLS]
  );

  return (
    <section className="export-settings-section export-type-section">
      <div className="export-settings-section__about">
        <h4 className="h5 export-settings-section__title">Export Type</h4>
      </div>
      <div className="export-settings-section__content">
        <RadioButtonGroup
          active={active}
          options={options}
          name="export-type"
          className="export-settings-section__options export-type-options"
          enabled
          onChange={onChange}
        />
      </div>
    </section>
  );
};

ExportType.propTypes = {
  active: T.string.isRequired,
  disableXLS: T.bool.isRequired,
  onChange: T.func.isRequired,
};

export default ExportType;
